import { render } from "./ClientSecretsManager.vue?vue&type=template&id=5235f7ce&scoped=true"
import script from "./ClientSecretsManager.vue?vue&type=script&lang=js"
export * from "./ClientSecretsManager.vue?vue&type=script&lang=js"

import "./ClientSecretsManager.vue?vue&type=style&index=0&id=5235f7ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5235f7ce"]])

export default __exports__